<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-col cols="12">
      <base-material-card
        color="coolrunner"
        :icon="icon"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t('homerunner') }}
          </div>
        </template>

        <v-col style="text-align: center;">
          <v-select
            v-model="terminal"
            prefix="Terminal: "
            single-line
            item-text="label"
            item-value="value"
            :items="terminals"
          />
          <input
            v-model="code"
            style="font-size: 32px; border: 2px solid grey; padding: 10px 5px; width: 100%; border-radius: 10px; text-align: center"
            :placeholder="$t('enter_package_number')"
            @keypress.enter="scan"
          >
          <v-btn
            class="mt-2 ml-auto"
            color="primary"
            large
            :disabled="!code || loading"
            :loading="loading"
            @click="scan"
          >
            {{ $t('scan') }}
          </v-btn>
          <v-col
            cols="6"
            class="mx-auto"
          >
            <v-card
              v-if="result.status !== null"
              inline
              class="px-5 py-3"
              :color="result.status ? 'green' : 'red'"
            >
              <v-col style="text-align: center;">
                <div
                  :class="'text-h3' + (!result.status ? ' white--text' : '')"
                >
                  {{ result.status ? `${result.booked_deliveries}/${result.package_numbers} ${$t('succesfully_booked')}` : $t('failed_booking') }}
                </div>
              </v-col>
            </v-card>
          </v-col>
          <v-col
            v-if="result.stopped_routes && result.stopped_routes.length"
            cols="12"
            class="mx-auto"
          >
            <h3 class="py-3">
              Stoppede pakker
            </h3>

            <v-data-table
              :items="result.stopped_routes"
              :headers="[
                {
                  text: $t('package_number'),
                  value: 'package_number',
                  sortable: false
                },
                {
                  text: $t('stopped_comment'),
                  value: 'fraud_comment',
                  sortable: false

                }]"
              dense
              disable-pagination
              hide-default-footer
            />
          </v-col>
        </v-col>
      </base-material-card>
      <base-card
        v-if="scannedPackages.length"
        class="px-5 py-3"
      >
        <v-container>
          <h3 class="py-3">
            Scannede Paller
          </h3>
          <v-row
            v-for="shipments in scannedPackages"
            :key="shipments.barcode"
            class="xs3"
          >
            <v-col
              md="4"
              :class="'text-h4'"
            >
              {{ shipments.barcode }}
            </v-col>
            <v-col
              md="4"
              :class="'text-h4'"
            >
              Pakker scannet {{ shipments.booked_deliveries }}/{{ shipments.package_numbers }}
            </v-col>
            <v-col
              md="4"
              :class="'text-h4'"
            >
              {{ shipments.date }}
            </v-col>
          </v-row>
        </v-container>
      </base-card>
    </v-col>
    <base-loading-overlay :loading="loadingPdf" />
  </v-container>
</template>

<script>
  import Auth from '@/mixins/Auth'
  import { handleErrorResponse } from '@/plugins/data'
  import print from 'print-js'
  import { PCN } from '../../../utils/constants'

  export default {
    mixins: [Auth],
    data () {
      return {
        crudl: {
          C: PCN.val,
          R: PCN.val,
          U: PCN.val,
          D: PCN.val,
          L: PCN.val,
          COOLRUNNER_ONLY: false,
        },
        endpoint: 'homerunner',
        name: 'homerunner',
        icon: 'mdi-truck-fast-outline',
        code: '',
        terminal: 'coolrunner_noerresundby',
        terminals: [{
                      label: 'Nordjyske (Aalborg)', value: 'nordjyske_aalborg',
                    },
                    {
                      label: 'UBD (Taastrup)', value: 'ubd_taastrup',
                    },
                    {
                      label: 'CoolRunner (Nørresundby)', value: 'coolrunner_noerresundby',
                    }],
        loading: false,
        loadingPdf: false,
        result: {
          stopped_routes: null,
          package_numbers: null,
          booked_deliveries: null,
          status: null,
        },
      }
    },
    computed: {
      scannedPackages () {
        return this.$store.state.scannedPackages
      },
    },
    watch: {
      scannedPackages () {},
    },
    created: function () {
      const userEmail = this.$getUser().email
      if (userEmail.includes('ubd.dk')) {
        this.terminal = 'ubd_taastrup'
      } else if (userEmail.includes('nordjyske.dk')) {
        this.terminal = 'nordjyske_aalborg'
      }
      this.date = this.$moment().format('LLL')
      this.$store.commit('REMOVE_OLD_PACKAGES', this.date)
    },
    methods: {
      scan: function () {
        this.loading = true
        this.result = {
          package_numbers: null,
          booked_deliveries: null,
          stopped_routes: null,
          status: null,
        }

        if (this.code.length === 8 && !isNaN(this.code)) {
          const chunks = this.code.match(/.{1,2}/g)
          this.code = `HR-${chunks.join('-')}`
        }

        this.$post(`${this.endpoint}/scan`, { package_number: this.code, terminal: this.terminal })
          .then(({ data }) => {
            this.result = data.response_data
            this.saveShipment({ ...this.result, barcode: this.code, date: this.date })
            this.$_.each(data.response_data.fml, fml => {
              this.loadingPdf = `${this.$t('fetching_label')}...`
              this.$get(`/homerunner/route/${fml}/label`, {}, { responseType: 'blob' })
                .then(r => {
                  print({
                    printable: URL.createObjectURL(r.data),
                    type: 'pdf',
                    onPrintDialogClose: () => { this.loadingPdf = null },
                    onPdfOpen: () => { this.loadingPdf = null },
                    onError: handleErrorResponse,
                  })
                })
                .catch(e => {
                  this.loadingPdf = null
                })
            })
            this.code = ''
            this.$playSound('/sounds/success.mp3')
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
      saveShipment: function (val) {
        this.$store.commit('SAVE_SCANNED_PACKAGE', val)
      },
    },
  }
</script>
